<template>
  <div>
    <button
        id="applyCv"
        :class="config.applyWithCVButtonClass"
        class="btn tracking-cv w-100"
        href=""
        type="button"
        @click.prevent="fileInputElement?.click()"
    >
      <i :class="[semaphore > 0 ? 'fa-spinner fa-pulse' : 'fa-file-alt']" class="far"></i>{{ buttonLabel }}
    </button>
    <div v-if="errorMessage" class="alert alert-danger mt-1">{{ errorMessage }}</div>
    <input id="cvFile" ref="fileInputElement" accept="application/pdf" class="d-none" type="file" @change="upload">
  </div>
</template>

<script lang="ts" setup>
import type {Dictionary} from "../types.ts";
import {inject, ref} from "vue";
import axios, {type AxiosError} from "axios";
import {Collapse} from 'bootstrap';
import type Provider from "../provider.ts";

interface Props {
  postUrl: string
  content: Dictionary<any>
  config: Dictionary<any>
  slug: string
}

const {postUrl, content, config, slug} = defineProps<Props>();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const fileInputElement = ref<HTMLInputElement>();

const buttonLabel = ref<string>(content.applyWithCVButtonText);

const errorMessage = ref<false | string>(false);

const semaphore = (inject('Provider') as Provider).refs.semaphore;

const upload = () => {
  semaphore.value++;
  if (fileInputElement.value?.files && fileInputElement.value?.files.length > 0) {

    errorMessage.value = false;

    const formData = new FormData();
    const file = fileInputElement.value.files[0];
    formData.append('file', file);

    axios.post(
        postUrl + slug,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: progressEvent => {
            const percent = progressEvent.progress ? progressEvent.progress * 100 : 0;
            buttonLabel.value = percent.toString() + '%';
          }
        })
        .then(response => {
          buttonLabel.value = response.data.filename + ' ✓';

          Object.entries(response.data.cvData as Dictionary<string>).forEach(([name, value]) => {
            const element = document.querySelector(`input[name="${name}"]`) as HTMLInputElement;
            if (element) {
              element.value = value;
            }
          });
        })
        .catch((error: AxiosError) => {
          if (error.response) {
            if (error.response.status === 422) {
              errorMessage.value = error.response?.data?.message as string
                  || 'Ein Fehler ist aufgetreten, versuche es später erneut.';
              return;
            }
          }

          errorMessage.value = 'Ein Fehler ist aufgetreten, versuche es später erneut.'
          buttonLabel.value = content.applyWithCVButtonText;

        })
        .finally(() => {
          // attach to dropzone
          document.querySelector('.dropzone')?.dropzone.addFile(file);
          // expand form
          Collapse.getOrCreateInstance('#formExtended').show()
          semaphore.value--;
        });
  }
}
</script>
